import React from 'react';

import { fixWebmDuration } from "@fix-webm-duration/fix";

import Button from "@mui/joy/Button";
import {Stack} from "@mui/joy";


let startTime

class AudioCapture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRecording: false,
            audioBlob: null,
            audioUrl: null,
            error: null
        };

        this.mediaRecorder = null;
        this.audioChunks = [];
        this.stream = null;
    }

    async startRecording() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia(
                {
                    audio: true,
                }
            );

            // Initialize MediaRecorder with audio chunks
            this.mediaRecorder = new MediaRecorder(
                this.stream,
                {
                    mimeType: 'audio/webm'
                }
            );
            this.audioChunks = [];

            // Capture data in chunks
            this.mediaRecorder.ondataavailable = (event) => {
                this.audioChunks.push(event.data);
            };

            // Handle recording stop
            this.mediaRecorder.onstop = async () => {
                const audioBlob = new Blob(
                    this.audioChunks,
                    {
                        type: 'audio/webm'
                    }
                );
                const duration = Date.now() - startTime;
                const newBlob = await fixWebmDuration(audioBlob, duration);
                const audioUrl = URL.createObjectURL(newBlob);
                if (this.stream) {
                    this.stream.getTracks().forEach(track => track.stop());
                }
                this.setState({
                    isRecording: false,
                    audioBlob: newBlob,
                    audioUrl: audioUrl
                });

            };

            // Start recording
            this.mediaRecorder.start();
            startTime = Date.now();
            this.setState({isRecording: true, error: null});

        } catch (error) {
            console.error('Error accessing microphone:', error);
            this.setState({
                isRecording: false,
                error: 'Failed to access microphone. Please check permissions.'
            });
        }
    }

    stopRecording() {
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
            this.mediaRecorder.stop();
        }
    }

    saveAudio(){
        this.props.saveCallBack(this.state.audioBlob)
        this.setState({
            isRecording: false,
            audioBlob: null,
            audioUrl: null,
            error: null
        })
    }

    render() {
        return (
            <Stack
                direction={'row'}
                spacing={1}
            >
                <Button
                    onClick={this.state.isRecording ? this.stopRecording.bind(this) : this.startRecording.bind(this)}
                    disabled={!!this.state.error}
                    color={this.state.isRecording ? 'danger' : 'neutral'}
                    size={'sm'}
                >
                    {this.state.isRecording ? 'Стоп' : 'Запиcать звук'}
                </Button>

                {/*{this.state.error && <div style={{ color: 'red' }}>{this.state.error}</div>}*/}

                {this.state.audioUrl && (
                    <Stack
                        direction={'row'}
                        spacing={1}
                    >
                        <audio
                            controls
                            src={this.state.audioUrl}
                            style={{
                                height: '30px',
                            }}
                        />
                        <Button
                            size={'sm'}
                            onClick={() => this.saveAudio()}
                            color={'success'}
                        >
                            Сохранить
                        </Button>
                    </Stack>
                )}
            </Stack>
        );
    }
}


export default AudioCapture;